const body = document.body
const navigationPrimary = document.querySelector(".navigation-primary")
const menuToggle = document.querySelector(".menu-toggle")
const burgerIcon =
  '<svg fill="none"height="24"viewBox="0 0 24 24"width="24"xmlns="http://www.w3.org/2000/svg"><rect fill="currentColor"height="2"width="22"x="1"y="4"/><rect fill="currentColor"height="2"width="22"x="1"y="18"/><rect fill="currentColor"height="2"width="22"x="1"y="11"/></svg>'
const closeIcon =
  '<svg fill="none"height="24"viewBox="0 0 24 24"width="24"xmlns="http://www.w3.org/2000/svg"><rect fill="currentColor"height="2"transform="rotate(-45 2 21.1702)"width="26.7596"x="2"y="21.1702"/><rect fill="currentColor"height="2"transform="rotate(-135 21 22.1702)"width="26.5248"x="21"y="22.1702"/></svg>'

function updateMenuToggleText() {
  if (navigationPrimary.classList.contains("is-visible")) {
    menuToggle.innerHTML = closeIcon
  } else {
    menuToggle.innerHTML = burgerIcon
  }
}

export function handleMenuToggle() {
  if (window.innerWidth < 640) {
    navigationPrimary.classList.toggle("is-visible")
    menuToggle.classList.toggle("is-visible")
    body.classList.toggle("no-scroll")

    updateMenuToggleText()
  }
}

menuToggle.addEventListener("click", handleMenuToggle)
// window.addEventListener("resize", handleMenuToggle)
